import {TableFooterColumn, TableFooterRow} from './TableFooterBase'
import {TableHeaderProps} from './TableFooterProps'

function TableFooter({columns, headerExternalLeftBorder, headerExternalRightBorder, handleSort, ...props}: TableHeaderProps) {
  return (
    <TableFooterRow headerExternalLeftBorder={headerExternalLeftBorder} headerExternalRightBorder={headerExternalRightBorder}>
      {columns.map((column, index) => {
        return (
          <TableFooterColumn {...props} key={index} charAmount={column.name.length} cursor={column.name && handleSort ? 'pointer' : 'auto'}>
            {column.name}
          </TableFooterColumn>
        )
      })}
    </TableFooterRow>
  )
}

export default TableFooter
